import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import doLogin from "./helpers/loginHandler.ts";
import { useEffect } from "react";
import { getNotFoundErrorURL, getSystemErrorURL } from "../bookshelfLinks.ts";
import chameleonjs from "chameleonjs";
import { DeweySchema } from "./helpers/brandSchema.ts";
import { noticeError } from "../../common/api/monitoring/index.ts";

function goToSystemError(brand?: DeweySchema) {
  const params = brand ? { locale: brand.locale } : {};

  // System error page should allow history back, as the error
  // may be something recoverable
  window.location.href = getSystemErrorURL(params);
}

function goTo404Error(brand?: DeweySchema) {
  const baseParams = brand
    ? { locale: brand.locale, theme: brand.Theme.primary }
    : {};

  // 404 page back button should not take you back to a non-existent page,
  // as that would just loop back to the error again
  window.location.replace(
    getNotFoundErrorURL({
      ...baseParams,
      missingURL: window.location.href,
    })
  );
}

export default function RootErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    if (error instanceof Error) {
      noticeError(error);
    }
  }, [error]);

  useEffect(() => {
    void chameleonjs
      .loadBrand<DeweySchema>(window.location.hostname, "dewey")
      .catch(() => {
        // Just don't provide brand data
        return undefined;
      })
      .then((brand) => {
        if (isRouteErrorResponse(error)) {
          if (error.status === 401) {
            doLogin();
          } else if (error.status === 404) {
            goTo404Error(brand);
          } else {
            goToSystemError(brand);
          }
        } else {
          goToSystemError(brand);
        }
      });
  }, [error]);

  return null;
}
